// extracted by mini-css-extract-plugin
module.exports = {"testimonial-wrapper":"testimonials_testimonial-wrapper__HRXMB"};